import makeStyles from '@mui/styles/makeStyles'

export default makeStyles(() => ({
  leftAlignText: {
    textAlign: 'left',
    marginLeft: 0,
    marginRight: 0 
  }
}))
